module.exports = __webpack_public_path__ + "static/img/3114-01.82e2c66c.jpg";